import hasFeature from 'modules/core/lib/hasFeature'

export default (hasRegularAccess: boolean) => {
  if (!hasFeature('employee_onboarding')) return true

  return hasRegularAccess
}
